const DeltaModule = require("../../../node_modules/quill-delta/dist/Delta");

const Delta = DeltaModule.default || DeltaModule;

module.exports = {
  Delta,
  AttributeMap: Delta.AttributeMap,
  Op: Delta.Op,
  OpIterator: Delta.OpIterator,
};
